module.exports = __webpack_public_path__ + "cd8b06c648aa1271e560dd901c64ee14.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/drumsticks.png
// module id = 2517
// module chunks = 0